export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8186.65aeb8a5.jpg";